var render = function render(){var _vm=this,_c=_vm._self._c;return _c('label',{staticClass:"formulate-input-label",class:{ colored: _vm.isRequired },attrs:{"for":_vm.context.id}},[_vm._v(" "+_vm._s(_vm.context.label)+" "),(_vm.isRequired)?_c('span',{staticClass:"required-mark"},[_vm._v(" (*)")]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }